import { QueryClient, QueryClientProvider } from '@tanstack/react-query'

//types
interface IProps {
	children: React.ReactNode
}

const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			retry: 2,
			refetchOnWindowFocus: true,
			refetchOnMount: true,
			refetchOnReconnect: true,
			refetchIntervalInBackground: false
		}
	}
})

//Query keys
enum QueryKeys {
	EXAMPLE = 'EXAMPLE',
	SUBSCRIPTIONS = 'SUBSCRIPTIONS',
	CHECK_USER = 'CHECK_USER',
	LOGIN = 'LOGIN',
	OAUTH_LOGIN = 'OAUTH_LOGIN',
	CHECK_CUPOM = 'CHECK_CUPOM',
	VERIFY_COUPON = 'VERIFY_COUPON',
	RECOVER_PASSWORD = 'RECOVER_PASSWORD',
	PRE_REGISTER = 'PRE_REGISTER',
	DATA_BY_TOKEN = 'DATA_BY_TOKEN',
	SEND_SUBSCRIPTION = 'SEND_SUBSCRIPTION',
	PIX = 'PIX'
}

//provider
function QueryProvider({ children }: IProps) {
	return (
		<QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
	)
}

export { QueryProvider, QueryKeys }
